import { defineMessages } from 'react-intl';

const definedMessages = defineMessages({
  title: {
    id: 'app.signup.employee.title',
    description: 'App download title',
    defaultMessage: 'Get the app',
  },
  title_variation: {
    id: 'app.signup.employee.title_variation',
    description: 'App download title variation',
    defaultMessage: 'Time clocks are set up by employers',
  },
  subtitle: {
    id: 'app.signup.employee.subtitle',
    description: 'App download subtitle',
    defaultMessage: 'Built for employees. See your schedules, time off, and more.',
  },
  subtitle_variation: {
    id: 'app.signup.employee.subtitle_variation',
    description: 'App download subtitle variation',
    defaultMessage: 'If your employer uses Tanda, download the app to see your schedules and more.',
  },
  ios: {
    id: 'app.signup.employee.ios',
    description: 'iOS download link',
    defaultMessage: 'Get on Apple Store',
  },
  android: {
    id: 'app.signup.employee.android',
    description: 'Android download link',
    defaultMessage: 'Get on Play Store',
  },
});

export default definedMessages;



// WEBPACK FOOTER //
// ./src/components/sign_up/sign_up_employee/i18n.js